import { post, get, getAuthHeader } from './base';
import { API_URL } from '../configuration';
import { useQuery } from 'react-query';
import {AttractionData} from '../types/CustomType';


//取得預設標籤
const findDefault = async () => {
    const response = await get(
        `${API_URL}/api/attraction?query_type=public`,
        getAuthHeader() // 加入 token header
    );
    return response.data;
}

const findTag = async (tag_id : string) =>{ 
    //console.log("findTag");
    const response = await get(`${API_URL}/api/attraction?query_type=tag&tag_id=${tag_id}`);
    //console.log(response);
    return response.data;
}


  
const getData = async (tag_id : string): Promise<AttractionData[]> => {
    const response = await get(`${API_URL}/api/attraction?query_type=tag&tag_id=${tag_id}`);
    return await response.data.message;
};

const getDataByArea = async (tag_id : string,city : string,district : string): Promise<AttractionData[]> => {
    const response = await get(`${API_URL}/api/attraction?query_type=tag&tag_id=${tag_id}&city=${city}&district=${district}`, getAuthHeader());
    return await response.data.message;
};


const AttractionService = {
    findDefault,
    findTag,
    getData,
    getDataByArea,
}

export default AttractionService;
